import React from 'react';
import Cuesheet from 'main/components/show/cuesheet.responsive/cuesheet.jsx';
import CuesheetHeader from 'main/components/show/cuesheet.responsive/header.jsx';
import CuesheetFooter from 'main/components/show/cuesheet.responsive/footer.jsx';
import EventViewActions from 'flux/actions/EventViewActions';
import EventShowListActions from 'flux/actions/EventShowListActions';
import { Row, Col } from 'bootstrap';

export default React.createClass({
  displayName: 'ShowPage',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    return (
      <div className="csr-show-wrapper">
        <Row className="csr-header-wrapper">
          <Col lg={24}>
            <CuesheetHeader />
          </Col>
        </Row>
        <Row className="csr-body-wrapper">
          <Cuesheet {...this.props.params} />
        </Row>
        <Row className="csr-footer-wrapper">
          <Col lg={24}>
            <CuesheetFooter />
          </Col>
        </Row>
      </div>
    );
  },

  componentDidMount() {
    let { teamId, eventId } = this.context.router.state.params;

    EventViewActions.populate(teamId, eventId);
    EventShowListActions.populate(teamId, eventId);
  },
});
